/**
 * Logout Controller
 */
(function () {

	angular.module('app.logout')
		.controller('LogoutController', LoginController);

    LoginController.$inject = ['authentication', '$location', 'azureSettings','$rootScope'];
    function LoginController(authentication, $location, azureSettings, $rootScope) {
        var mfaredirect = localStorage.getItem('mfaredirect');
        // log out
		logout();
       
        function logout() {            
            var authdata = authentication.getAuthData();                     
            if (authdata || mfaredirect == 'true') { 
                localStorage.removeItem('cookiedata');
                localStorage.removeItem('mfaredirect');
                authentication.logout();
                var tenantName = azureSettings.tenantName;
                var policyName = azureSettings.passwordlessPolicy;
                var logouturl = azureSettings.azureLogoutUri;              
                var clientId = $location.search().clientId;
                var redirect = $location.search().redirect || $rootScope.redirectURL;                
                var redirectUri = redirect?redirect.split('#')[0]:"";   
               var url = "https://" + tenantName + ".b2clogin.com/" + tenantName + ".onmicrosoft.com/" + policyName + "/oauth2/v2.0/logout?post_logout_redirect_uri=" + logouturl + "&state=" + redirectUri + ';' + clientId;
                window.location.href = url;
            }           
                
                $location.path('/');            
		}
	}
})();